import { Order } from '../types';

export const getIfoodCommunicationId = (order: Order): string => (order.ifoodSupportId || '').trim();

export const hasValidIfoodCommunicationId = (order: Order): boolean => /^\d{8}$/.test(getIfoodCommunicationId(order));

export const requiresIfoodDeliveryValidation = (order: Order): boolean => {
  const salesChannel = (order.salesChannel || '').toLowerCase();

  if (salesChannel.includes('ifood')) return true;

  // Open Delivery is a protocol used by multiple origins. Only force the iFood
  // validation flow when the order actually carries the 8-digit iFood support ID.
  return hasValidIfoodCommunicationId(order);
};
